<template>
	<div class="mt6 xs-12 wrap">
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("type") }}</div>
		<j-base-input-text
			size="medium"
			v-model="inputType"
			@input="onInputChange"
		/>
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("value") }}</div>
		<j-base-input-text
			size="medium"
			v-model="inputValue"
			@input="onInputChange"
		/>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"

export default {
	name: "InputNewContact",
	components: {
		JBaseInputText
	},
	props: {
		value: {
			required: false
		}
	},
	data() {
		return {
			inputValue: "",
			inputType: ""
		}
	},

	methods: {
		onInputChange() {
			this.$emit("input", {
				value: this.inputValue,
				type: this.inputType
			})
		}
	}
}
</script>
